import API from "../api/phx";

export const markOrderPaymentStatusFailed = async (orderID, cancelUI=false, paymentMethod) => {
  const phxOrder = await API.get(`/orders/${orderID}`);
  const prevOrderStatus = phxOrder.data.status;

  if (cancelUI) {
    const admin_comment = {
      created:new Date().toISOString(),
      message:`${paymentMethod} widget closed without payment attempt`,
      name:"api_web",
    }
    phxOrder.data.comments_admin.push(admin_comment);
  } else {
    phxOrder.data.status = "payment_failed";
    if (prevOrderStatus !== "payment_failed") {
      const data = {
        order_id: `${orderID}`,
        payment: `failed`,
      };

      try {
        await API.post(`email/bloomreach/payment`,data, { withCredentials: true });
      } catch(err) {
        console.error('Error sending logs: ',err)
      }
    }
  }

  try {
    await API.put(`/orders/${orderID}`, phxOrder.data, { mode: "no-cors" });
  } catch (err) {
    console.error('Failed to mark order as "payment failed".', err);
  }
};
